import React from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// core components
import { Col, Container, Row } from "stories/layout"
import { useNotification } from "stories/components/Notification"
import { useAuthContext } from "contexts/AuthContext";

// Import the new LoginForm component
import LoginForm from "components/Forms/LoginForm/LoginForm";

const LoginView = ({match, history}) => {
  const { t } = useTranslation();
  const { getMyUser } = useAuthContext();
  const { notify } = useNotification();
  const navigate = useNavigate();
  
  const handleModalConfirm = () => {
    getMyUser();
  }
  
  const handleResolve = () => {
    notify({ 
      title: t('User', 'Käyttäjä'), 
      message: t('login_successful', 'Kirjautuminen onnistui')
    });
    handleModalConfirm();
    navigate('/');
  }
  
  return (
    <>
      <Container className="mt-5 pb-5">
        <Row className="justify-content-center">
          <Col lg="5" md="7" className="">
            <LoginForm 
              history={history} 
              t={t} 
              handleResolve={handleResolve} 
              notify={notify}
              navigate={navigate}
            />
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default LoginView;
